import { faqConstants } from "../constants/faqConstants";
import { faqService } from "../../services/API/faqService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const add_faq = (postData) => {
  return (dispatch) => {
    dispatch(request());
    faqService.add_faq(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.ADD_FAQ_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.ADD_FAQ_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.ADD_FAQ_FAILURE, error };
  }
};

export const get_faq_list = (postData) => {
  return (dispatch) => {
    dispatch(request());
    faqService.get_faq_list(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.GET_FAQ_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.GET_FAQ_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.GET_FAQ_LIST_FAILURE, error };
  }
};

export const get_faq_details = (quesID) => {
  return (dispatch) => {
    dispatch(request());
    faqService.get_faq_details(quesID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.GET_FAQ_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.GET_FAQ_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.GET_FAQ_DETAILS_FAILURE, error };
  }
};

export const update_faq = (postData) => {
  return (dispatch) => {
    dispatch(request());
    faqService.update_faq(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.UPDATE_FAQ_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.UPDATE_FAQ_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.UPDATE_FAQ_DETAILS_FAILURE, error };
  }
};

export const delete_faq = (quesID) => {
  return (dispatch) => {
    dispatch(request());
    faqService.delete_faq(quesID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.DELETE_FAQ_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.DELETE_FAQ_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.DELETE_FAQ_FAILURE, error };
  }
};

export const get_faq_frontend = (quesID) => {
  return (dispatch) => {
    dispatch(request());
    faqService.get_faq_frontend(quesID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.GET_FAQ_FRONTEND_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.GET_FAQ_FRONTEND_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.GET_FAQ_FRONTEND_DETAILS_FAILURE, error };
  }
};

export const add_vote = (postData) => {
  return (dispatch) => {
    dispatch(request());
    faqService.add_vote(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.ADD_FAQ_VOTE_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.ADD_FAQ_VOTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.ADD_FAQ_VOTE_FAILURE, error };
  }
};

export const get_faq_check_vote = (postData) => {
  return (dispatch) => {
    dispatch(request());
    faqService.get_faq_check_vote(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: faqConstants.GET_FAQ_VOTE_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: faqConstants.GET_FAQ_VOTE_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: faqConstants.GET_FAQ_VOTE_DETAILS_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/faqAction.js